import { ReactNode } from 'react';
import { BottomNavigation } from '@/components/common/BottomNavigation';

interface SellerPageContainerProps {
  children: ReactNode;
  className?: string;
  activeNavId?: string;
}

export function SellerPageContainer({ 
  children, 
  className = '', 
  activeNavId = 'dashboard' 
}: SellerPageContainerProps) {
  return (
    <div className="flex flex-col h-screen bg-[#F5F5F5]">
      {/* 스크롤 가능한 메인 콘텐츠 영역 */}
      <main className="flex-grow overflow-y-auto pb-20">
        <div 
          className={`min-h-screen bg-white ${className}`}
          style={{ 
            paddingTop: '16px',
            paddingLeft: '16px',
            paddingRight: '16px'
          }}
        >
          {children}
        </div>
      </main>

      {/* 하단 네비게이션 */}
      <BottomNavigation 
        activeId={activeNavId}
        userRole="seller"
        platform="mobile"
      />
    </div>
  );
}